import { shouldPaint } from '../paint/projection';
import type { PaintSurface } from '../paint/types';
import type { InfoCard } from './workspace.types';

/** Apply paint projection to the info-board feed (Evidence can be suppressed). */
export function paintVisibleInfoCards(
  cards: InfoCard[],
  paintShell: PaintSurface
): InfoCard[] {
  const paintEvidence = shouldPaint('evidence', 'window', paintShell);
  if (paintEvidence) return cards;
  return cards.filter((card) => card.kind !== 'evidence');
}
